import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Container } from "semantic-ui-react";
import ManuscriptAddBlockMenu from "./ManuscriptAddBlockMenu";

/**
 * ManuscriptAddBlock : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Action to add a manuscript content block
 * in the editor
 */
class ManuscriptAddBlock extends Component {
  state = {
    /**
     * isOpen: Boolean
     * True if the popover connected to the action button
     * is currently visible
     */
    isOpen: false
  };

  /**
   * setMenuOpen = open => ()
   * Sets whether the popover menu containing action types
   * is open or closed
   */
  setMenuOpen = open => this.setState({ isOpen: open });

  /**
   * createBlock = type => ()
   * Closes the menu and fires a block creation event
   */
  createBlock = type => {
    this.setMenuOpen(false);
    this.props.onClick(type);
  };

  /**
   * render = () => ()
   * Renders the component, consisting of the menu
   * and its trigger
   */
  render() {
    return (
      <Container textAlign="center">
        <ManuscriptAddBlockMenu
          trigger={
            <Button onClick={() => this.setMenuOpen(true)} icon>
              <Icon name="plus" />
            </Button>
          }
          position="top center"
          createBlock={this.createBlock}
          onOpen={() => this.setMenuOpen(true)}
          onClose={() => this.setMenuOpen(false)}
          isOpen={this.state.isOpen}
        />
      </Container>
    );
  }
}

ManuscriptAddBlock.propTypes = {
  /**
   * onClick = type => ()
   * Fired when a block type is selected that should be
   * created
   */
  onClick: PropTypes.func.isRequired
};

export default ManuscriptAddBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/ManuscriptAddBlock.js